"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const RadioSlider = (_a) => {
    var { name, value, onChange, options, columnBreakpoint, column, activeColor, activeBackground, boxShadow = true } = _a, rest = __rest(_a, ["name", "value", "onChange", "options", "columnBreakpoint", "column", "activeColor", "activeBackground", "boxShadow"]);
    return (react_1.default.createElement(Wrapper, Object.assign({ boxShadow: boxShadow }, rest),
        react_1.default.createElement(Content, { column: column, columnBreakpoint: columnBreakpoint },
            value && value !== "" && (react_1.default.createElement(Background, { column: column, columnBreakpoint: columnBreakpoint, activeBackground: activeBackground, active: options.findIndex(el => el[1] === value), length: options.length })),
            options.map(el => {
                // const optionValue = el[1]
                // const text = el[0].text ?? el[0]
                // const icon = el[0].icon
                // const flexDirection = el[0].flexDirection ?? "row"
                // const params = el[2] ?? {}
                const optionValue = el[1];
                const text = el[0];
                const flexDirection = "row";
                return (react_1.default.createElement(Option, { key: optionValue, className: "option", active: value === optionValue, onClick: () => onChange({
                        name,
                        value: optionValue,
                    }), activeColor: activeColor, flexDirection: flexDirection }, text));
            }))));
};
exports.default = RadioSlider;
const Background = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  background-color: ${({ theme, activeBackground = "primary" }) => { var _a; return (_a = theme.color[activeBackground]) !== null && _a !== void 0 ? _a : activeBackground; }};
  width: calc(100% / ${({ length }) => length});
  height: 100%;
  position: absolute;
  left: ${({ length, active }) => `calc((100% / ${length}) * ${active})`};
  top: 0;
  z-index: 0;
  transition: left 0.5s, top 0.5s;
  border-radius: ${({ theme }) => theme.variable.borderRadius};

  ${({ length, columnBreakpoint, active }) => columnBreakpoint &&
    (0, styled_components_1.css) `
      @media (max-width: ${columnBreakpoint}px) {
        width: 100%;
        height: calc(100% / ${length});
        left: 0 !important;
        top: ${`calc((100% / ${length}) * ${active})`};
      }
    `};

  ${({ length, column, active }) => column &&
    (0, styled_components_1.css) `
      width: 100%;
      height: calc(100% / ${length});
      left: 0 !important;
      top: ${`calc((100% / ${length}) * ${active})`};
    `};
`;
const Option = styled_components_1.default.button `
  font-family: "Poppins" !important;
  cursor: pointer;
  padding: 0 ${({ theme }) => theme.space.S};
  height: 45px;
  min-height: 45px;
  font-size: ${({ theme }) => theme.font.M};
  font-weight: ${({ theme }) => theme.font.normal};
  color: ${({ theme }) => theme.color.second};
  border: 0px;
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  color: ${({ theme, active, activeColor = "white" }) => { var _a; return active ? (_a = theme.color[activeColor]) !== null && _a !== void 0 ? _a : activeColor : theme.color.second; }};
  transition: color 0.3s;
  background: none;
  z-index: 1;
  position: relative;
  flex: 1 1;
  margin: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${({ flexDirection = "row" }) => flexDirection};

  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      cursor: not-allowed;
    `};

  @media (max-width: 400px) {
    font-size: ${({ theme }) => theme.font.S};
  }
`;
const Content = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  width: 100%;
  display: flex;

  ${({ columnBreakpoint }) => columnBreakpoint &&
    (0, styled_components_1.css) `
      @media (max-width: ${columnBreakpoint}px) {
        flex-direction: column;
      }
    `};

  ${({ column }) => column &&
    (0, styled_components_1.css) `
      flex-direction: column;
    `};
`;
const Wrapper = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  background: ${({ theme, background = "white" }) => theme.color[background]};
  width: ${({ width }) => width || "100%"};
  max-width: ${({ maxWidth }) => maxWidth || "none"};
  padding: 5px;
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  position: relative;
  display: flex;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  ${({ theme, boxShadow }) => boxShadow &&
    (0, styled_components_1.css) `
      box-shadow: ${theme.variable.boxShadow};
    `}
`;
//# sourceMappingURL=RadioSlider.js.map